import { useCallback } from 'react';
import { useAuthFetch } from '@cko/dashboard-shared';

import { API_PATHS } from '../../../../../environment/apiPaths';

export const useUpdateReadStatus = () => {
  const fetch = useAuthFetch();

  return useCallback(
    async (notificationId: string, isRead: boolean): Promise<void> => {
      const endpoint = `${API_PATHS.notificationsApiBasePath}/${notificationId}?isRead=${isRead}`;
      await fetch(endpoint, {
        method: 'PUT',
      });
    },
    [fetch],
  );
};
